<app-notes 
    [id]="orderId" 
    [user]="user" 
    [notesDisplay]="orderNotes"
    [businessId]="fsOrderDetails?.BusinessId"
    [driverId]="fsOrderDetails?.assigned_drivers?.length > 0 ? fsOrderDetails?.assigned_drivers[0].driver_id : null"
    [driverName]="fsOrderDetails?.DriverNames?.length > 0 ? fsOrderDetails?.DriverNames[0] : null"
    [notesTypes]="notesTypes.Order"
    [warehouseId]="fsOrderDetails?.WarehouseId"
    ></app-notes>
